import { v4 as uuid } from "uuid";
import React, { useEffect, useState, useRef} from "react";
import store from "@/redux/store";
import { useNavigate, Link } from "react-router-dom";
import PPCEditor from "@/views/base/editor/Editor"
import {FieldHolder} from "@/components/holders/FieldHolder";
import { PPCTimeField } from "@/components/datetime/PPCTimeField";
import {showConfirmModal, hideModal, showStoreConfirmModal} from "@/reducers/ModalPopup";
import {storeWorklog} from "@/reducers/Dossier";

import { useForm, Controller, SubmitHandler } from "react-hook-form"

const items = [


  { name: 'Taak annuleren', href: '#' },
]



function classNames(...classes) {
  return classes.filter(Boolean).join(' ')
}

export default function ContactBladView(props) {
  const { register, handleSubmit, watch, reset,    formState, setValue, getValues, control } = useForm({
      defaultValues: {...props.selected},
    })
    const myRef = useRef(null);
    const [item, setItem] = useState((props?.selected) ? props?.selected : {description:''});
    
    let firstAction = null;
    let otherActions = [];
    let data = (props?.data) ? props?.data : []; 
     const sanitizedData = () => ({
        __html: (data?.description)
      })

const handleBut = (event) => {
    event.preventDefault();
    store.dispatch(showStoreConfirmModal({item: props?.data, action: confirmedSaveHandler}));
    
    return false;
}

const confirmedSaveHandler = (data) => {
    let worklogData = {dossierKey: data.item.key, ...getValues()}
    store.dispatch(storeWorklog(worklogData))
    store.dispatch(hideModal());
}

const handleWYSWIG=(html) => {
    
    setValue('knowledge_paperchip', myRef.current.props.getHTML(), { shouldDirty: true});
}


const onSubmit = (data) => {
    

    return false;
    }

const updateItemSingleValue=((changedItem, field, value) => {

    let indexKey = ''; //changedItem.indexKey;
    if(indexKey == "") {
        indexKey = field;
    } else {
        indexKey = indexKey+"."+field;
    }
    setValue(indexKey, value);
    setValue('updateKey', uuid().slice(0, 8));

//    let newItem = {...changedItem}
//    newItem.updateKey = uuid().slice(0, 8);
//    newItem[field] = value;


//    setItem(newItem);
    
});    

    const cancelEventHandler = (event) =>  {
        if(props?.closeModal) {
            props?.closeModal();   
        }
    };


  return (
    <>
<form className="bg-white shadow-sm  w-full" onSubmit={null}>
         <div className=" space-y-8 border-b border-gray-900/10 pb-12 sm:space-y-0 sm:divide-y sm:divide-gray-900/10 sm:border-t sm:pb-0">
            <div className="sm:grid sm:grid-cols-8 sm:items-start sm:gap-1 sm:py-4">
              <label htmlFor="username" className="block text-sm/6 font-medium text-gray-900 sm:pt-1.5 col-span-8">
                Aantal uur en minuten gewerkt
              </label>
              <div className="mt-2 sm:col-span-1 sm:mt-0 col-span-4">
                <div className="flex items-center rounded-md bg-white pl-3 outline-1 -outline-offset-1 outline-gray-300 focus-within:outline-2 focus-within:-outline-offset-2 focus-within:outline-indigo-600 sm:max-w-md">
                    <PPCTimeField name="workhours"  hourCycle={24} onChange={(name, time) => { updateItemSingleValue(item, 'duration', time); }} />
                </div>
              </div>
            </div>
        </div>


                <FieldHolder colspan="12" smcolspan="8" label="Werkverslag" className="max-h-40" id="name" error={props?.state?.error}>
<PPCEditor ref={myRef} key={'12'} content={item.description}  
setValue={setValue} reset={reset} getValues={getValues} formState={formState} fieldKey={''}
fieldName="description" className={"component block h-40 w-full rounded-md border-0 py-.5 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-indigo-600 sm:text-sm sm:leading-6 p-2"}/>

</FieldHolder>    

            <div className="mt-5 sm:mt-4 sm:flex sm:flex-row-reverse">
              <button
                type="button"
                  onClick={(event) => {handleBut(event)}}
                className="inline-flex w-full justify-center rounded-md bg-red-600 px-3 py-2 text-sm font-semibold text-white shadow-sm hover:bg-red-500 sm:ml-3 sm:w-auto"
              >
                Opslaan
              </button>
              <button
                type="button"
                data-autofocus
                onClick={(event) => cancelEventHandler(event)}
                className="mt-3 inline-flex w-full justify-center rounded-md bg-white px-3 py-2 text-sm font-semibold text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 hover:bg-gray-50 sm:mt-0 sm:w-auto"
              >
                Annuleer
              </button>
            </div>

</form>
    </>
    );
      
}      